// Desfazer a liberação de uma parcela para faturamento — "liberei por engano"
// (Lucas, 30/09/2026). Uma peça só, usada nas TRÊS telas que têm o botão
// Liberar (Contas a Receber, Medições e a aba Financeiro do contrato): a
// confirmação, o motivo e — o que importa — o recado quando o aviso ao
// financeiro NÃO sai.
//
// Liberar dispara o e-mail "NF a emitir". Desfazer dispara o "NÃO emitir" para
// a mesma lista (Financeiro › Cadastros › Avisos). Se o envio falhar, o
// servidor responde `email_enviado: false` e a tela manda a pessoa avisar na
// mão — silêncio aqui é a nota saindo assim mesmo.
import { Input, Typography } from 'antd';
import axios from 'axios';
import { API_URL } from '../config';
import { getToken } from './auth';

type Parcelinha = {
  id: string;
  descricao?: string | null;
  parcela_titulo?: string | null;
  valor_previsto?: number | string | null;
};

const brl = (v: any) => (parseFloat(String(v ?? 0)) || 0)
  .toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

/** Abre a confirmação e, no OK, desfaz a liberação. `onFeito` recarrega a tela. */
export function pedirDesfazerLiberacao(
  { modal, message, parcela, onFeito }:
  { modal: any; message: any; parcela: Parcelinha; onFeito: () => void },
) {
  const nome = parcela.parcela_titulo || parcela.descricao || 'parcela';
  // Referência solta (não estado): o modal.confirm lê no onOk, como o
  // "Confirma recebimento" já faz com o valor.
  let motivo = '';
  modal.confirm({
    title: 'Desfazer a liberação desta parcela?',
    width: 520,
    content: (
      <div>
        <Typography.Paragraph style={{ fontSize: 13, marginBottom: 10 }}>
          <b>{nome}</b> — {brl(parcela.valor_previsto)}.<br />
          A parcela volta a NÃO estar liberada e quem emite a nota recebe um e-mail
          <b> avisando para não emitir</b>.
        </Typography.Paragraph>
        <Typography.Text type="secondary" style={{ fontSize: 11 }}>Motivo (vai no e-mail e no histórico)</Typography.Text>
        <Input.TextArea rows={2} maxLength={300} placeholder="Ex.: liberei a parcela errada"
          onChange={(e) => { motivo = e.target.value; }} />
      </div>
    ),
    okText: 'Desfazer liberação',
    okButtonProps: { danger: true },
    cancelText: 'Cancelar',
    onOk: async () => {
      try {
        const token = await getToken();
        const r = await axios.post(`${API_URL}/comercial/propostas-geradas`,
          { action: 'fin_revogar_liberacao', id: parcela.id, motivo: motivo.trim() || undefined },
          { headers: { Authorization: token } });
        const d = r.data?.body ? JSON.parse(r.data.body) : r.data;
        if (d?.email_enviado) {
          const quem = (d.destinatarios || []).join(', ');
          message.success(`Liberação desfeita. Aviso enviado${quem ? ` para ${quem}` : ''}.`);
        } else {
          // 8 segundos: é um recado com tarefa, não um "ok".
          message.warning({
            content: 'Liberação desfeita, mas o e-mail de aviso NÃO saiu. Avise quem emite a nota.',
            duration: 8,
          });
        }
        onFeito();
      } catch (e: any) {
        const d = e.response?.data;
        message.error('Erro: ' + (d?.error || d?.erro || e.message));
        throw e;   // mantém o modal aberto para a pessoa ler o motivo da recusa
      }
    },
  });
}
